module.exports = __webpack_public_path__ + "img/edit.98f74d69.svg";